@let locales = locales$ | async;

@if (locales != null && locales.length > 1) {
    <button
        [matMenuTriggerFor]="menu"
        aria-label="menu"
        mat-icon-button
        matTooltip="{{ 'shared.i18n.tooltip' | translate }}"
    >
        @if (currentLanguage$ | async; as currentLanguage) {
            <img
                [src]="'i18n/countries/' + currentLanguage + '.svg'"
                alt="{{ 'shared.i18n.' + currentLanguage | translate }}"
            />
        }
    </button>
    <mat-menu #menu="matMenu">
        @for (locale of locales; track locale) {
            <button
                (click)="setDefaultLanguage(locale)"
                mat-menu-item
            >
                <mat-icon [svgIcon]="'flags:' + locale" />
                <span>{{ 'shared.i18n.' + locale | translate }}</span>
            </button>
        }
    </mat-menu>
}
